export default [{
  path: '/stage/attendance',
  name: 'stage-attendance',
  title: '出勤',
  component: () => import('@/views/stage/template/attendance/index')
}, {
  path: '/stage/attendance/record',
  name: 'attendance-record',
  title: '出勤记录',
  component: () => import('@/views/stage/template/attendance/template/record')
}];
